import { render, staticRenderFns } from "./SpaceResearchBar.vue?vue&type=template&id=6601e4ba&scoped=true"
import script from "./SpaceResearchBar.vue?vue&type=script&lang=js"
export * from "./SpaceResearchBar.vue?vue&type=script&lang=js"
import style0 from "./SpaceResearchBar.vue?vue&type=style&index=0&id=6601e4ba&prod&scoped=true&lang=css"
import style1 from "./SpaceResearchBar.vue?vue&type=style&index=1&id=6601e4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6601e4ba",
  null
  
)

export default component.exports